import {get, post} from "../APIGateWay";

export async function getPackages(params = {'os' : 'web'}) {
    return await get(params, '/package/all')
}

export async function getFeature(params = {'os' : 'web', 'package_type' : 'feature'}) {
    return await get(params, '/package/all')
}

export async function postPayment(data) {
    return await post(data, '/payment')
}

export async function paymentDetail(params) {
    return await get(params, '/payment/info')
}